import React, { useEffect, useState } from "react";
import axios from "axios";
import { UserConsumer } from "../../../UserContext";
import { myOfficeHoursAPIs } from "./myOfficeHoursAPIs";
import StatusBar from "./StatusBar";
import Header from "../../../components/Header";
import { Button } from "reactstrap";
import { AlertPopups } from "../../../components/AlertPopups";
import { Redirect } from "react-router-dom";

const LateNotification = () => {
	let token = null;
	const [status, setStatus] = useState([]);
	const [selectedOccurenceType, setSelectedOccurenceType] = useState("");
	const [hourValue, setHourValue] = useState("0");
	const [occureceLimit, setOccurenceLimit] = useState("0");
	const [minuteValue, setMinuteValue] = useState("0");

	useEffect(() => {
		getOfficeHoursStatus();
		getLateNotification();
	}, []);

	const getOfficeHoursStatus = () => {
		axios
			.get(`${myOfficeHoursAPIs.GetOccurenceType_API}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				const sendData = [];
				if (res) {
					res.data.occuranceTypes.forEach((item) =>
						sendData.push({ label: item.label, value: item.value })
					);
				}
				setStatus(sendData);
			});
	};
	const getLateNotification = () => {
		axios
			.get(`${myOfficeHoursAPIs.GetLateNotification_API}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				setOccurenceLimit(res.data.occurenceLimit);
				setSelectedOccurenceType(res.data.occurenceType);
				const timelimt = res.data.timeLimit.split(":");
				setHourValue(timelimt[0]);
				setMinuteValue(timelimt[1]);
			});
	};

	const hourChangeHandler = (e) => {
		setHourValue(e.target.value);
	};
	const minutesChangeHanlder = (e) => {
		setMinuteValue(e.target.value);
	};
	const occurenceLimitHandler = (e) => {
		setOccurenceLimit(e.target.value);
	};
	const onOccurencetypeChange = (value) => {
		setSelectedOccurenceType(value);
	};
	const handleSubmitt = () => {
		const data = {
			timeLimitHours: hourValue,
			timeLimitMinutes: minuteValue || "00",
			occurenceLimit: occureceLimit,
			occuranceType: selectedOccurenceType,
		};
		axios
			.put(`${myOfficeHoursAPIs.GetLateNotification_API}`, data, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(() => {
				AlertPopups.successAlert.fire({
					text: "Late Notification Updated",
				});
			})
			.catch((error) => {
				if (error.response) {
					if (occureceLimit === "") {
						AlertPopups.ErrorAlert.fire({
							text: "Please Enter Limit",
						});
					} else if (hourValue === "") {
						AlertPopups.ErrorAlert.fire({
							text: "Please Enter hours",
						});
					} else if (minuteValue === "") {
						AlertPopups.ErrorAlert.fire({
							text: "Please Enter Minutes",
						});
					} else if (occureceLimit > 365) {
						AlertPopups.ErrorAlert.fire({
							text: `Occurance limit Must be between 0 to 365`,
						});
					}
				}
			});
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return userDetails.empRole.includes("3") ? (
					<div className="container-fluid pl-3 pr-3">
						<Header title="Late Notification" headerBorder={true} />

						<StatusBar
							hourChangeHandler={hourChangeHandler}
							minutesChangeHanlder={minutesChangeHanlder}
							occurenceLimitHandler={occurenceLimitHandler}
							hourvalue={hourValue}
							minutevalue={minuteValue}
							occurenceLimitValue={occureceLimit}
							status={status}
							selectedOccurenceType={selectedOccurenceType}
							onOccurencetypeChange={(value) => {
								setSelectedOccurenceType(value);
								onOccurencetypeChange(value.value);
							}}
						/>
						<div
							style={{
								display: "flex",
								justifyContent: "end",
							}}
						>
							<Button
								type="submit"
								className="approve-btn mt-1"
								onClick={handleSubmitt}
							>
								Save
							</Button>
						</div>
					</div>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
};

export default LateNotification;
